module.exports = __webpack_public_path__ + "static/img/suspension.3def62b.png";


//////////////////
// WEBPACK FOOTER
// ./app/content/images/suspension.png
// module id = JsaR
// module chunks = 11